/** Keeps table searches and CSV exports on the same date-only, nullable filter contract. */
export const toDailyUpdateReportRequest = (query: Record<string, any>) => ({
    ...query,
    intakeDate: query.intakeDate?.slice(0, 10) || null,
    createdDateFrom: query.createdDateFrom?.slice(0, 10) || null,
    createdDateTo: query.createdDateTo?.slice(0, 10) || null,
    state: query.state || null,
    customerHold: typeof query.customerHold === "boolean" ? query.customerHold : null,
    customerIds: query.customerIds || [],
    branchIds: query.branchIds || [],
    type: query.type || [],
    productStatuses: query.productStatuses || [],
    orderStatus: query.orderStatus || [],
    followUpTypes: query.followUpTypes || [],
});
